import React, { useState, useRef, useLayoutEffect } from 'react';


function ExpandableText({ text, className = '', maxLines = 4 }) {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const checkOverflow = () => {
      const overflowing = element.scrollHeight > element.clientHeight + 1;
      setIsOverflowing(overflowing);
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [text, maxLines, expanded]);

  return (
    <div className="tw-flex tw-flex-col tw-items-start expandable-text-wrapper">
      <p
        ref={textRef}
        className={`tw-m-0 tw-whitespace-pre-wrap [word-break:break-word] [overflow-wrap:anywhere] [&.clamped]:[display:-webkit-box] [&.clamped]:[-webkit-box-orient:vertical] [&.clamped]:tw-overflow-hidden [&.expanded]:tw-block [&.expanded]:tw-overflow-visible expandable-text   ${className}      ${expanded ? "expanded" : "clamped"}`}
        style={!expanded ? { WebkitLineClamp: maxLines } : undefined}
      >
        {text}
      </p>
      {(isOverflowing || expanded) && (
        <button
          type="button"
          className={"tw-bg-[none] tw-border-0 tw-p-0 tw-mt-[4px] tw-text-[#2563eb] tw-text-[0.85rem] tw-font-medium tw-cursor-pointer [&:hover]:tw-underline expandable-text-toggle"}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
}

export default ExpandableText;
